"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Operationalimpactanalysis() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const problemPoints = [{
    text: "Menor satisfacción del huésped"
  }, {
    text: "Más consultas en recepción"
  }, {
    text: "Más incidencias operativas"
  }, {
    text: "Menor eficiencia en restauración y servicios"
  }];
  return <section data-section-id="4553" id="operationalimpactanalysis" className="bg-background text-foreground py-12 md:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-5">
            <p className="font-mono text-xs tracking-widest uppercase text-[color:var(--chart-1)] mb-6">
              El Problema
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-foreground">
              La incertidumbre genera esperas innecesarias.
            </h2>
          </div>
          
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="space-y-6 max-w-2xl">
              <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/90">
                Los huéspedes esperan sin saber cuándo llegará el próximo transporte.
              </p>
              <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground/90">
                Los equipos operativos trabajan sin información actualizada sobre horarios reales de llegada.
              </p>
              
              <div className="pt-8 border-t border-border/40">
                <h3 className="font-mono text-sm tracking-wider uppercase text-foreground mb-6">
                  El resultado:
                </h3>
                <ul className="space-y-4">
                  {problemPoints.map((point, i) => <li key={i} data-index={i} className="flex items-start gap-4 group">
                      <span className="mt-1.5 size-1.5 shrink-0 bg-[color:var(--chart-1)]" />
                      <span className="font-default text-base text-muted-foreground/90 group-hover:text-foreground transition-colors duration-300">
                        {point.text}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-24 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-10 border-t border-border">
          <p className="font-default text-sm text-muted-foreground/80 max-w-xl">Gestiona la movilidad de tu complejo con la solución integral de TimeArrival.</p>
          <Button asChild size="lg" className="bg-[color:var(--chart-1)] text-[color:var(--primary-foreground)] hover:bg-[color:var(--chart-1)]/90 font-mono text-xs tracking-widest uppercase rounded-md">
            <Link to="/BookDemoPage">SOLICITAR PRESENTACION</Link>
          </Button>
        </div>
      </div>
    </section>;
}